import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { IndexedArray } from '@common/types';
import { AnalyticsPlanningStore } from '../types/store';
import { createBoardRoutine } from '../actions';
import initialState from '../store';
import { AnalyticsBoardModel } from '@common/types/dictionaries/analytics';

export const createBoardReducer = createReducer<AnalyticsPlanningStore>(initialState as AnalyticsPlanningStore, {
  [createBoardRoutine.REQUEST]: (state) => {
    state.Boards.adding = true;
    return state;
  },
  [createBoardRoutine.SUCCESS]: (
    state,
    action: PayloadAction<{
      data: IndexedArray<AnalyticsBoardModel>;
    }>
  ) => {
    const { data } = action.payload;

    if (data && state.Boards?.data) {
      state.Boards.data = { ...state.Boards?.data, ...data };
    }

    return state;
  },
  [createBoardRoutine.FAILURE]: (state) => {
    return state;
  },
  [createBoardRoutine.FULFILL]: (state, action: PayloadAction<any>) => {
    state.Boards.adding = false;
    return state;
  }
});
